import cx from "classnames";
import * as React from "react";
import { JSX } from "react";

export interface QESCardProps {
  /**
   * Content to go in the body of the card
   */
  children: React.ReactNode;
  /**
   * Extra className string to go on the container (.qes-card)
   */
  classNames?: string;
  /**
   *  The title of the card
   */
  title: string;
}

/**
 * This component isn't really in the style guide, but it was used in the bulk terminations work (on step 4)
 */
export const QESCard = (props: QESCardProps): JSX.Element => {
  return (
    <div
      className={cx({
        "qes-card": true,
        [props.classNames]: !!props.classNames,
      })}
    >
      <div className="qes-card__title">{props.title}</div>
      <div className="qes-card__body">{props.children}</div>
    </div>
  );
};
